import { useMutation } from 'react-query';

import { UploadFailureReason } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export interface PendingFailure {
  filename: string;
  extension: string;
  rejectedReason: UploadFailureReason;
}

interface SendPendingFailuresParams {
  caseId: string;
  uploadId: string;
  failures: PendingFailure[];
}

export const useSendPendingFailures = ({ matterId }: { matterId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation(
    async ({ caseId, uploadId, failures }: SendPendingFailuresParams) => {
      if (failures.length === 0) {
        return;
      }

      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: {
          uploadId,
          caseId,
          failures: failures.map((f) => ({
            filename: f.filename,
            extension: f.extension,
            rejectedReason: f.rejectedReason,
          })),
        },
      });

      const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/upload-metadata/failure`, fetchConfig);
      if (!response.ok) {
        throw new Error(`Failed to record upload failures: ${response.status}`);
      }
    },
    {
      onError: (error) => {
        console.error('Failed to record upload failures:', error);
      },
    },
  );
};
